import dayjs from "dayjs";

export const getTomorrow = () => {
    return dayjs().add(1, 'day').format('YYYY-MM-DD');
};

export const formatDateToMMDDYYYY = (date) => {
    return dayjs(date).format('MM-DD-YYYY');
};